import Radio from '@components/Radio';
import Row from '@components/Row';
import Stepper from '@components/Stepper';
import Text from '@components/Text';
import styled from '@emotion/styled';
import usePriceUnit from '@hooks/item/usePriceUnit';
import { ItemOption } from '@models/item';
import useOptionControl from '@store/item/hooks/useOptionControl';
import getGlobalName from '@utils/getGlobalName';
import { Fragment } from 'react';

import { getFormatedOptionPrice, getPricePrefix } from './utils/priceUtils';

interface Props {
    options: ItemOption[];
    optionGroupId: string;
    itemId: string;
    optionType: 'default' | 'personal';
}

function RadioOptions({
    options, optionGroupId, itemId, optionType,
}:Props) {
    const {
        selectOption, isOptionSelected, watchOptionCount, watchOptionMaxCount,
    } = useOptionControl({ itemId });
    const priceUnit = usePriceUnit();

    return (
        <Fragment>
            {options.map((option) => {
                const {
                    name, salePrice, optionId, isChangeable, maxQuantity, nameEn, nameKo, nameJa,
                } = option;
                const optionName = getGlobalName({
                    nameKo, nameEn, name, nameJa,
                });
                const isPriceVisible = salePrice !== 0;
                const isStepperVisible = maxQuantity > 1 && isChangeable;
                return (
                    <OptionRow key={option.optionId}>
                        <Radio value={optionId}
                            disabled={!isChangeable}
                            onChange={() => selectOption({ option, optionGroupId, amount: 1 })}
                            isSelected={isOptionSelected({ optionId, optionGroupId })}
                            aria-label='option'
                            data-display-type='radio'
                            data-option-id={optionId}
                            data-option-name={optionName}
                            data-price={salePrice}
                            data-option-type={optionType}
                        >
                            <Row justify='space-between' fullWidth>
                                <Row>
                                    {optionName}
                                    {isPriceVisible && (
                                        <PriceText as='span' >
                                            {getFormatedOptionPrice(salePrice)}{priceUnit}
                                        </PriceText>
                                    )}
                                </Row>
                                {isStepperVisible && (
                                    <Stepper size='sm'
                                        value={watchOptionCount(optionId, optionGroupId)}
                                        min={0}
                                        increase={() => selectOption({ option, optionGroupId, amount: 1 })}
                                        decrease={() => selectOption({ option, optionGroupId, amount: -1 })}
                                        max={watchOptionMaxCount(optionId, optionGroupId)} />
                                )}
                            </Row>
                        </Radio>
                    </OptionRow>
                );
            })}
        </Fragment>
    );
}

const OptionRow = styled.div`
    padding: var(--spacing-2) 0;
    width: 100%;
`;

const PriceText = styled(Text)`
    margin-left: var(--spacing-2);
`;

export default RadioOptions;
